import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import PublicIcon from '@mui/icons-material/Public';
import RestoreIcon from '@mui/icons-material/Restore';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminAttendance from '../../../app/admin/attendance';
import AdminCalendar from '../../../app/admin/calendar';
import AdminDashboard from '../../../app/admin/dashboard';
import AdminDepartments from '../../../app/admin/departments';
import DepartmentUpdate from '../../../app/admin/departments/components/DepartmentUpdate';
import AdminEmployees from '../../../app/admin/employees';
import EmployeeCreate from '../../../app/admin/employees/components/EmployeeCreate';
import EmployeeUpdate from '../../../app/admin/employees/components/EmployeeUpdate';
import EmployeePreview from '../../../app/admin/employees/preview/EmployeePreview';
import AdminExpenses from '../../../app/admin/expenses';
import ExpenseCreate from '../../../app/admin/expenses/components/ExpenseCreate';
import ExpenseUpdate from '../../../app/admin/expenses/components/ExpenseUpdate';
import AdminHolidays from '../../../app/admin/holidays';
import HolidayCreate from '../../../app/admin/holidays/components/HolidayCreate';
import HolidayUpdate from '../../../app/admin/holidays/components/HolidayUpdate';
import AdminLeaveDays from '../../../app/admin/leave-days';
import AdminNotifications from '../../../app/admin/notifications';
import AdminOfficeOrderly from '../../../app/admin/office-orderly';
import AdminProjects from '../../../app/admin/projects';
import ProjectCreate from '../../../app/admin/projects/components/ProjectCreate';
import ProjectUpdate from '../../../app/admin/projects/components/ProjectUpdate';
import AdminRefund from '../../../app/admin/refund';
import RefundCreate from '../../../app/admin/refund/components/RefundCreate';
import RefundUpdate from '../../../app/admin/refund/components/RefundUpdate';
import AdminSettings from '../../../app/admin/settings';
import AdminTeamContributions from '../../../app/admin/team-contributions';
import TeamContributionsCreate from '../../../app/admin/team-contributions/components/TeamContributionsCreate';
import TeamContributionsUpdate from '../../../app/admin/team-contributions/components/TeamContributionsUpdate';
import { EModules } from '../../../shared/enums/modules/EModules';

export const adminRoutes = [
  {
    module: EModules.DASHBOARD,
    path: '/admin/dashboard',
    showInSidebar: true,
    title: 'header.dashboard',
    component: <AdminDashboard />,
    icon: <DashboardOutlinedIcon />,
  },
  {
    module: EModules.ATTENDANCE,
    path: '/admin/attendance',
    showInSidebar: true,
    title: 'header.attendance',
    component: <AdminAttendance />,
    icon: <RestoreIcon />,
  },
  {
    module: EModules.USERS,
    path: '/admin/employees',
    showInSidebar: true,
    title: 'header.employees',
    component: <AdminEmployees />,
    icon: <Groups2OutlinedIcon />,
  },
  {
    module: EModules.USERS,
    path: '/admin/employees/create/:tab',
    component: <EmployeeCreate />,
  },
  {
    module: EModules.USERS,
    path: '/admin/employee/:id/:tab',
    showInSidebar: false,
    title: 'header.employee',
    component: <EmployeeUpdate />,
  },
  {
    module: EModules.USERS,
    path: '/admin/employee/preview/:id/',
    showInSidebar: false,
    title: 'header.employee',
    component: <EmployeePreview />,
  },
  {
    module: EModules.DEPARTMENTS,
    path: '/admin/departments',
    showInSidebar: true,
    title: 'header.departments',
    component: <AdminDepartments />,
    icon: <BadgeOutlinedIcon />,
  },
  {
    module: EModules.DEPARTMENTS,
    path: '/admin/departments/:id',
    component: <DepartmentUpdate />,
  },
  {
    module: EModules.PROJECTS,
    path: '/admin/projects',
    showInSidebar: true,
    title: 'header.projects',
    component: <AdminProjects />,
    icon: <AccountTreeOutlinedIcon />,
  },
  {
    module: EModules.PROJECTS,
    path: '/admin/projects/create',
    component: <ProjectCreate />,
  },
  {
    module: EModules.PROJECTS,
    path: '/admin/projects/:id',
    component: <ProjectUpdate />,
  },
  {
    module: EModules.CALENDAR,
    path: '/admin/calendar',
    showInSidebar: true,
    title: 'header.calendar',
    component: <AdminCalendar />,
    icon: <CalendarMonthIcon />,
  },
  {
    module: EModules.LEAVE_DAYS,
    path: '/admin/leave-days',
    showInSidebar: true,
    title: 'header.leaveDays',
    component: <AdminLeaveDays />,
    icon: <BeachAccessOutlinedIcon />,
  },
  {
    module: EModules.HOLIDAY,
    path: '/admin/holiday',
    showInSidebar: true,
    title: 'header.holiday',
    component: <AdminHolidays />,
    icon: <PublicIcon />,
  },
  {
    module: EModules.HOLIDAY,
    path: '/admin/holiday/create',
    component: <HolidayCreate />,
  },
  {
    module: EModules.HOLIDAY,
    path: '/admin/holiday/:id',
    component: <HolidayUpdate />,
  },
  {
    module: EModules.EXPENSES,
    path: '/admin/expenses',
    showInSidebar: true,
    title: 'header.expenses',
    component: <AdminExpenses />,
    icon: <PaidOutlinedIcon />,
  },
  {
    module: EModules.EXPENSES,
    path: '/admin/expenses/create',
    component: <ExpenseCreate />,
  },
  {
    module: EModules.EXPENSES,
    path: '/admin/expenses/:id',
    component: <ExpenseUpdate />,
  },
  {
    module: EModules.TEAM_CONTRIBUTIONS,
    path: '/admin/team-contributions',
    title: 'header.team-contributions',
    component: <AdminTeamContributions />,
  },
  {
    module: EModules.TEAM_CONTRIBUTIONS,
    path: '/admin/team-contributions/create',
    component: <TeamContributionsCreate />,
  },
  {
    module: EModules.TEAM_CONTRIBUTIONS,
    path: '/admin/team-contributions/:id',
    component: <TeamContributionsUpdate />,
  },
  {
    module: EModules.REFUND,
    path: '/admin/refund',
    showInSidebar: true,
    title: 'header.refund',
    component: <AdminRefund />,
    icon: <CurrencyExchangeIcon />,
  },
  {
    module: EModules.REFUND,
    path: '/admin/refund/create',
    component: <RefundCreate />,
  },
  {
    module: EModules.REFUND,
    path: '/admin/refund/:id',
    component: <RefundUpdate />,
  },
  {
    module: EModules.OFFICE_ORDERLY,
    path: '/admin/office-orderly',
    showInSidebar: true,
    title: 'header.officeOrderly',
    component: <AdminOfficeOrderly />,
    icon: <PendingActionsOutlinedIcon />,
  },
  {
    path: '/admin/settings',
    showInSidebar: true,
    title: 'header.settings',
    component: <AdminSettings />,
    icon: <SettingsSuggestOutlinedIcon />,
  },
  {
    module: EModules.NOTIFICATION,
    path: '/admin/notifications',
    showInSidebar: false,
    title: 'header.notifications',
    component: <AdminNotifications />,
  },
  {
    path: '*',
    component: <Navigate to="/admin/dashboard" />,
  },
];
